import styles from './Form.module.scss'

interface FormProps {
  onSubmit: (data: any) => void
  children: React.ReactNode
  errorMessage?: string
}

export const Form: React.FC<FormProps> = (props: FormProps) => {
  const { onSubmit, children, errorMessage } = props

  return (
    <form onSubmit={onSubmit} className={styles.form}>
      {children}
      {errorMessage && <div className={styles.errorFooter}>{errorMessage}</div>}
    </form>
  )
}
